<div class="kt-portlet" [ngClass]="class" #portlet>
	<ng-content></ng-content>
</div>
